var map = {
	"./former_leader_01.png": 52936,
	"./former_leader_03.png": 1124,
	"./former_leader_04.png": 48467,
	"./former_leader_05.png": 6640,
	"./former_leader_06.png": 29936,
	"./former_leader_07.png": 44349,
	"./former_leader_08.png": 33710,
	"./former_leader_09.png": 13583,
	"./former_leader_10.png": 60878,
	"./former_leader_11.png": 77553,
	"./former_leader_13.png": 7188,
	"./former_leader_15.png": 74922,
	"./former_leader_16.png": 12035,
	"./former_leader_17.png": 94352,
	"./former_leader_18.png": 26843,
	"./former_leader_19.png": 39252,
	"./former_leader_21.png": 20143,
	"./former_leader_22.png": 10752,
	"./former_leader_23.png": 33488,
	"./former_leader_24.png": 28236,
	"./former_leader_25.png": 47107,
	"./former_leader_26.png": 34667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70204;